var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 7.50008V2.50008C18.3333 2.38709 18.3108 2.27935 18.2701 2.1811C18.2297 2.08353 18.17 1.99208 18.091 1.9126L18.0875 1.90906C17.9368 1.75929 17.7292 1.66675 17.5 1.66675H12.5C12.0397 1.66675 11.6666 2.03984 11.6666 2.50008C11.6666 2.96032 12.0397 3.33341 12.5 3.33341H15.4881L10.2441 8.57749C9.91862 8.90293 9.91862 9.43057 10.2441 9.756C10.5695 10.0814 11.0971 10.0814 11.4226 9.756L16.6666 4.51193V7.50008C16.6666 7.96032 17.0397 8.33341 17.5 8.33341C17.9602 8.33341 18.3333 7.96032 18.3333 7.50008ZM8.33331 5.00008C8.79355 5.00008 9.16665 4.62699 9.16665 4.16675C9.16665 3.70651 8.79355 3.33341 8.33331 3.33341H5.83331C4.4526 3.33341 3.33331 4.4527 3.33331 5.83342V14.1667C3.33331 15.5475 4.4526 16.6667 5.83331 16.6667H14.1666C15.5474 16.6667 16.6666 15.5475 16.6666 14.1667V11.6667C16.6666 11.2065 16.2936 10.8334 15.8333 10.8334C15.3731 10.8334 15 11.2065 15 11.6667V14.1667C15 14.627 14.6269 15.0001 14.1666 15.0001H5.83331C5.37308 15.0001 4.99998 14.627 4.99998 14.1667V5.83342C4.99998 5.37318 5.37308 5.00008 5.83331 5.00008H8.33331Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalLink);
export default __webpack_public_path__ + "static/media/internal-link.1a84a326c9b6e485cc58ed6571087684.svg";
export { ForwardRef as ReactComponent };